export default __webpack_public_path__ + "static/media/mailIcon.7948ad29.svg";